import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import { SaleCenterClosingSummary } from "../../types/sale-center-closing.type";
import { formatDateTimeBkk } from "../../utils/date";
import { MISSING_VALUE, SEND_BACK_LABEL } from "./saleCenterClosing.utils";

interface ClosingSentBackAlertProps {
  summary: SaleCenterClosingSummary;
}

/**
 * Why head office handed this branch-day back, above everything else in the panel.
 *
 * Full width and first, for EVERY role rather than the cohort that may close: the branch
 * cannot correct what it cannot read, and the reason is the whole instruction it has been
 * given. It sits outside the two columns because it belongs to the branch-day itself, not to
 * the sign-offs on one side or the closing form on the other.
 */
export default function ClosingSentBackAlert({
  summary,
}: ClosingSentBackAlertProps) {
  const sentBackAtLabel = formatDateTimeBkk(summary.sent_back_at);

  return (
    <Alert severity="warning">
      <AlertTitle sx={{ fontWeight: 700 }}>{SEND_BACK_LABEL}</AlertTitle>
      <Typography variant="body2">
        โดย {summary.sent_back_by_name ?? MISSING_VALUE}
        {sentBackAtLabel ? ` · ${sentBackAtLabel} น.` : ""}
      </Typography>
      {summary.sent_back_reason && (
        <Typography variant="body2">
          เหตุผล: {summary.sent_back_reason}
        </Typography>
      )}
    </Alert>
  );
}
